/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/lift_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M11.5 23.207l-2.854-2.853.708-.708 2.146 2.147 2.146-2.147.708.708z"/><path pid="1" d="M11.5 20.207l-2.854-2.853.708-.708 2.146 2.147 2.146-2.147.708.708z"/><path pid="2" d="M11.5 17.207l-2.854-2.853.708-.708 2.146 2.147 2.146-2.147.708.708zM22.646 12.354L20.5 10.207l-2.146 2.146-.708-.707L20.5 8.792l2.854 2.854z"/><path pid="3" d="M22.646 15.354L20.5 13.207l-2.146 2.146-.708-.707 2.854-2.854 2.854 2.854z"/><path pid="4" d="M22.646 18.354L20.5 16.207l-2.146 2.146-.708-.707 2.854-2.854 2.854 2.854zM15 4h2v24h-2zM8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
